import Actions from './smart-url-actions';
import Collection from './smart-url-collection';
import Model from './smart-url-model';
import reducer from './smart-url-reducer';
import Selectors from './smart-url-selectors';

export default {
  Actions,
  Collection,
  Model,
  namespace: 'smartUrl',
  reducer,
  Selectors,
};
